module.exports = __webpack_public_path__ + "static/media/user_blue.ef96b126.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user_blue.svg
// module id = 580
// module chunks = 1